export default "__VITE_ASSET__CTXkoJIl__"